import { Controller, useWatch } from "react-hook-form"

const FormCheckbox = ({ style = {}, label, name, register, control, disabled, onSelectedHandler }) => {

    const watchedValue = useWatch({
        control,
        name: name,
        exact: false
    });

    return (
        <div className="form-input-radio" style={{ cursor: 'pointer', padding: '.6rem 0rem', ...style }}>

            <Controller
                name={name}
                control={control}
                render={({ field }) => {
                    return (

                        <input
                            type='checkbox'
                            style={{ cursor: 'pointer' }}
                            // checked={!!field.value} //NOTE setValue null in the parent is not updating this
                            checked={!!watchedValue}
                            disabled={disabled}
                            onChange={(e) => {
                                field.onChange(e.target.checked);
                                onSelectedHandler?.(e.target.checked)
                            }}
                        />
                    )
                }}
            />
            <label htmlFor={label} style={{ cursor: 'pointer', width: '100%' }}>{label}</label>
        </div>
    )
}

export default FormCheckbox

